import { render } from "./RecruitmentPage.vue?vue&type=template&id=4ad1c1c3&scoped=true"
import script from "./RecruitmentPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentPage.vue?vue&type=script&lang=js"

import "./RecruitmentPage.vue?vue&type=style&index=0&id=4ad1c1c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad1c1c3"]])

export default __exports__